module.exports = __webpack_public_path__ + "img/intropage-connectors.8b80d4f8.svg";